import React, { useState, useEffect, useRef, useContext } from 'react';
import OwlCarousel from 'react-owl-carousel3';
import Accordion from 'react-bootstrap/Accordion';

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

import { useParams } from 'react-router-dom';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import InfiniteScroll from 'react-infinite-scroll-component';

import Header from '../layout/Header';
import Footer from '../layout/Footer';
import ProductList from './Component/ProductList';
import TopFilterBar from './Component/TopFilterBar';
import '../assets/css/collection-desktop.css';
import apiPath from "../constants/apiPath";
import Http from "../services/Http";
import toast, { Toaster } from 'react-hot-toast';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation } from 'react-router-dom';

import ImgCross from '../assets/img/close.png';
import ImgSortIc from '../assets/img/sort_ic.png';
import ImgFilterIc from '../assets/img/filter_ic.png';

import noProduct from '../assets/img/noProduct.png';

import LocalizedStrings from "react-localization";
import localization from "../localization";
import Modal from 'react-bootstrap/Modal';
import Imgcross from '../assets/img/cross.png';
import { Button, Form } from 'react-bootstrap';
import { SelectGroup, ValidationForm } from "react-bootstrap4-form-validation";

import { Helmet } from 'react-helmet';
import LoadingOverlay from 'react-loading-overlay-ts';
import ScrollContext from '../ScrollContext';
import Currency from './Component/Currency';

import { PRODUCT_PAGE_CONFIG } from '../productPageConfig';

let strings = new LocalizedStrings(localization);
const options = {
    rtl: true,
    margin: 0,
    nav: true,
    dots: false,
    loop: true,
    responsive: {
        0: {
            items: 1,
            margin: 7.5
        },
        420: {
            items: 1
        },
        577: {
            items: 1
        },
        992: {
            items: 1
        }
    }
};


const ProductPage = ({ type }) => {
    const config = PRODUCT_PAGE_CONFIG[type] || {};

    const { isScrolled } = useContext(ScrollContext);
    const location = useLocation();
    const formRef = React.createRef();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isActive, setActive] = useState(true)

    const setModalIsOpenToTrue = (item, attributes, variantImage) => {
        const firstAttrValues = attributes[0]?.attribute_values || [];
		const firstAttrValue = firstAttrValues[0];

		setComman(prev => ({
			...prev,
			product_id: item.id,
			attributes: attributes,
            product_variant_image: variantImage,
			product: item,
			attribute_value_id: firstAttrValue?.id || null
		}), () => {
			if (firstAttrValues.length > 1 && firstAttrValue?.id) {
				handleAttributeChange(item.id, firstAttrValue.id);
			}
		});
        setModalIsOpen(true)
    }

    const setModalIsOpenToFalse = () => {
        setModalIsOpen(false)
    }

    const showAddtoCart = async (e, item, attributes, variantImage) => {
        e.preventDefault();
        if (attributes.length > 0) {
            setModalIsOpenToTrue(item, attributes, variantImage);
        } else {
            setComman({ ...comman, product_id: item.id, attribute_value_id: null, product_variant_image: variantImage, product: item });
            addtoCart(item.id, null, variantImage);
        }
    };

    const handleAttributeChange = async (productId, attributeValueId) => {
		try {
			let path = apiPath.ProductAvailability + '/' + productId;
			var data = new FormData();
			data.append('attribute_value_id', attributeValueId);
			let options = {
				method: 'POST',
				data: data
			}
			let result = await Http(path, options);
			if (result.status == 200) {
				if (result.data.status) {
					setComman(prev => ({
						...prev,
						product: {
							...prev.product,
							discount_price: result.data.data.product.discount_price,
							original_price: result.data.data.product.original_price
						}
					}));
				}
				else {
					toast.error(result.data.message);
				}
			}
		} catch (error) {
		  console.error('Error updating price:', error);
		  toast.error('An error occurred while updating price');
		}
	};

    const addtoCart = async (id, type, variantImage) => {
        let path = apiPath.AddtoCart;
        var data = new FormData();
        data.append('product_id', id);
        data.append('qty', 1);
        data.append('is_increment', 1);
        if (type == null && comman.attribute_value_id != null) {
            data.append('product_attribute_values_id', comman.attribute_value_id);
        }
        else if (type == 'form') {
            const attributeValueId = document.querySelector('input[name="attribute_value_id"]:checked');
            if (attributeValueId != null && attributeValueId != "") {
                data.append('product_attribute_values_id', attributeValueId.value);
            }
        }

        if (variantImage) {
            data.append('variant_image_id', variantImage);
        }

        let options = {
            method: 'POST',
            data: data
        }

        let result = await Http(path, options);
        if (result.status == 200) {
            if (result.data.status) {
                toast.success(result.data.message);
            }
            else {
                toast.error(result.data.message);
            }
            setModalIsOpenToFalse();
        }
    }

    const metaLocal = {
        en: {
            title: "Exclusive Sale: Original Perfumes in Kuwait | TPS",
            description: "Luxury Kuwait perfume brands with exclusive offers. Shop original perfumes in Kuwait and enjoy unmatched fragrances at discounted prices.",
            keyword: "Sale"
        },
        ar: {
            title: "عرض حصري: العطور الأصلية في الكويت | TPS",
            description: "ماركات العطور الكويتية الفاخرة مع عروض حصرية. تسوق العطور الأصلية في الكويت واستمتع بعطور لا مثيل لها بأسعار مخفضة.",
            keyword: "أُوكَازيُون"
        }
    };

    const params = useParams();
    const shuffleSeedRef = useRef(Math.floor(Math.random() * 2147483647) + 1);
    const [open, setOpen] = React.useState(false);
    const [filters, setFilters] = useState([]);
    const [product, setProduct] = useState([]);
    const [value, setValue] = React.useState([2, 10]);
    const [comman, setComman] = useStateWithCallbackLazy({
        page: 1,
        last_page: 0,
        showLoad: 'showCl',
        minPrice: 0,
        maxPrice: 0,
        short: '',
        min_price: null,
        max_price: null,
        category: [],
        brand: [],
        rating: 0,
        notes: [],
        perfumeTypes: [],
        is_Wishlist: 0,
        product_id: 0,
        attributes: [],
        attribute_value_id: null,
        product_variant_image: null,
        product: null
    });
    const [currPage, setCurrPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [priceBounds, setPriceBounds] = useState({ min: 0, max: 0 });
    const [priceInput, setPriceInput] = useState({ from: '', to: '' });


    const handleOpen = () => {
        setOpen(!open);
    };

    const [currentLang, setCurrentLang] = useState(
        localStorage.getItem("current_lang")
            ? localStorage.getItem("current_lang")
            : "en"
    );
    strings.setLanguage(currentLang);



    const getProduct = async (page) => {
        setActive(true);
        let path = apiPath.product;
        var data = new FormData();
        
        const queryParams = new URLSearchParams(location.search);
        const searchValue = queryParams.get('search');
        if (searchValue) {
            data.append('name', searchValue);
        }

        data.append('page', page);
        data.append('type', params.type);
        data.append('typeId', params.typeId);
        if (config.defaultFilters) {
            Object.entries(config.defaultFilters).forEach(([key, value]) => {
                data.append(key, value);
            });
        }
        if (comman.brand.length > 0) {
            data.append('brand_id', comman.brand);
        }

        if (params.typeId == undefined && params.type != '' && params.type != undefined && comman.category.length <= 0 && comman.brand.length <= 0 && comman.rating <= 0 && comman.maxPrice <= 0 && comman.notes.length <= 0 && comman.perfumeTypes <= 0) {
            data.append('category_slug', params.type);
        }

        if (params.type == 'brand' && params.typeId != '' && comman.category.length <= 0 && comman.brand.length <= 0 && comman.rating <= 0 && comman.maxPrice <= 0 && comman.notes.length <= 0 && comman.perfumeTypes <= 0) {
            data.append('brand_id', params.typeId);
        }
        if (params.type == 'category' && params.typeId != '' && comman.category.length <= 0 && comman.brand.length <= 0 && comman.rating <= 0 && comman.maxPrice <= 0 && comman.notes.length <= 0 && comman.perfumeTypes <= 0) {
            data.append('category_id', params.typeId);
        }
        if (params.type == 'sub' && params.typeId != '' && comman.category.length <= 0 && comman.brand.length <= 0 && comman.rating <= 0 && comman.maxPrice <= 0 && comman.notes.length <= 0 && comman.perfumeTypes <= 0) {
            data.append('sub_category_id', params.typeId);
        }

        if (comman.category.length > 0) {

            data.append('category_id', comman.category);
        }

        if (comman.perfumeTypes.length > 0) {

            data.append('perfumeTypes', comman.perfumeTypes);
        }
        if (comman.notes.length > 0) {
            data.append('notes_id', comman.notes);
        }
        if (comman.rating > 0) {
            data.append('rating', comman.rating);
        }
        if (params.type == "price") {
            data.append('price', params.typeId);
        }
        if (params.type == "discount") {
            data.append('discount', params.typeId);
        }
        if (comman.min_price != null && comman.max_price != null) {
            data.append('min_price', comman.min_price);
            data.append('max_price', comman.max_price);
        }
        if (value > 0) {
            data.append('price', value);
        }
        if (comman.short) {
            data.append('order_by', comman.short);
        }
        else {
            data.append('shuffle_seed', shuffleSeedRef.current);
        }


        let options = {
            method: 'POST',
            data: data
        }

        let result = await Http(path, options);
        if (result.status === 200) {
            if (result.data) {
                let resultJson = result.data.result;

                if (page == 1) {
                    setProduct({
                        data: result.data.data.data,
                    })
                    setComman({ ...comman, last_page: result.data.data.last_page, page: page });
                }
                else {
                    setProduct({
                        data: product.data.concat(result.data.data.data)
                    })
                }

                if (currPage === result.data.data.last_page) {
                    setComman({ ...comman, showLoad: 'hideCl', page: page });
                    setHasMore(false)
                }


            } else {
                toast.error(result.data.message);
            }
        } else {
            if (result.statusText != null) {
                toast.error(result?.data?.message || result.statusText);
            }
        }
        setActive(false);
    }

    const getFilterData = async () => {
        let path = apiPath.getFilterData;
        let options = {
            method: 'POST',
        }

        let result = await Http(path, options);

        if (result.status === 200) {
            if (result.data.status) {
                const fd = result.data.data;
                setFilters({ data: fd });
                if (fd.min_price != null && fd.max_price != null) {
                    const min = Math.floor(parseFloat(fd.min_price));
                    const max = Math.ceil(parseFloat(fd.max_price));
                    setPriceBounds({ min, max });
                    setPriceInput({ from: String(min), to: String(max) });
                }
                // alert(filter.data.category)
            } else {
                toast.error(result.data.message);
            }
        } else {
            if (result.statusText != null) {
                toast.error(result?.data?.message || result.statusText);
            }
        }
    }

    const handleOnFilter = async (e, type, value) => {

        // alert(e.target.name)
        // alert(e.target.value)
        if (type === 'short') {
            // await setComman({ sort: e.target.value })
            // await getProduct(1, comman)
            await setComman({ ...comman, short: e.target.value })
        }
        if (type === 'category') {
            if (e.target.checked === true) {
                comman.category.push(value);
            }
            else {
                const array = comman.category
                var index = array.indexOf(value)
                if (index !== -1) {
                    array.splice(index, 1);
                    setComman({ ...comman, category: array });
                }
            }
            setComman({ ...comman, category: [...new Set(comman.category)] });


        }
        if (type === 'perfumeTypes') {
            if (e.target.checked === true) {
                comman.perfumeTypes.push(value);
            }
            else {
                const array = comman.perfumeTypes
                var index = array.indexOf(value)
                if (index !== -1) {
                    array.splice(index, 1);
                    setComman({ ...comman, perfumeTypes: array });
                }
            }
            setComman({ ...comman, perfumeTypes: [...new Set(comman.perfumeTypes)] });


        }

        if (type === 'brand') {
            if (e.target.checked === true) {
                comman.brand.push(value);
            }
            else {
                const array = comman.brand
                var index = array.indexOf(value)
                if (index !== -1) {
                    array.splice(index, 1);
                    setComman({ ...comman, brand: array });
                }
                // comman.brand.pop(value);
            }
            setComman({ ...comman, brand: [...new Set(comman.brand)] });
            getProduct(1, comman)
        }
        if (type === 'rating') {
            setComman({ ...comman, rating: value });
            // getProduct(1, comman)
            // await setComman({ ...comman, rating: value });
        }
        if (type === 'notes') {
            if (e.target.checked === true) {
                comman.notes.push(value);
            }
            else {
                comman.notes.pop(value);
            }
            setComman({ ...comman, notes: [...new Set(comman.notes)] });
            // getProduct(1, comman)

        }
        setCurrPage(prevPageNumber => 1)

    }

    const handleFavourite = async (e, id, type, index) => {

        let path = apiPath.AddRemoveWishlist;
        var data = new FormData()
        data.append('product_id', id);
        data.append('type', type);
        let options = {
            method: 'POST',
            data: data
        }

        let result = await Http(path, options);
        if (result.status === 200) {
            if (result.data.status) {
                var is_wish = product.data[index].is_wishlist;
                var is_wish_val = 0;

                if (type == 'add') {
                    setProduct({ ...product, [product.data[index].is_wishlist]: 0 });
                    setComman({ ...comman, is_Wishlist: 0 })
                    // getProduct(1)
                }
                else {
                    setProduct({ ...product, [product.data[index].is_wishlist]: 1 });
                    // getProduct(1)
                }

                toast.success(result.data.message);
            } else {
                toast.error(result.data.message);
            }
        } else {
            if (result.statusText != null) {
                toast.error(result?.data?.message || result.statusText);
            }
        }


    }

    const onScroll = async (e) => {
        // console.log((window.pageYOffset + document.documentElement.clientHeight).toFixed(0), document.documentElement.scrollHeight);
        console.log(comman.showLoad, "comman.showLoad")
        if (parseInt((window.pageYOffset + document.documentElement.clientHeight).toFixed(0)) === (document.documentElement.scrollHeight)) {
            if (comman.showLoad != "hideCl") {
                setCurrPage(prevPageNumber => prevPageNumber + 1)
            }


        }
    };

    const onNext = () => {
        if (hasMore) {
            setCurrPage(prevPageNumber => prevPageNumber + 1)
        }
    }

    useEffect((e) => {
        // window.scrollTo(0, 0)
        getFilterData();
        // window.addEventListener('scroll', onScroll);
        // return () => window.removeEventListener("scroll", onScroll)
    }, [])

    useEffect(() => {
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        // localStorage.setItem("type", params.type)
        getProduct(currPage);

    }, [currPage, params, comman.category, comman.brand, comman.rating, comman.notes, comman.perfumeTypes, comman.min_price, comman.max_price]);


    useEffect(() => {
        localStorage.setItem("type", params.type)
        getProduct(1);
    }, [value, comman.short]);

    const loadMore = (data) => {
        var page = comman.page
        page = page + 1;
        setComman({ ...comman, page: page });
        getProduct(page);
    }

    const priceChange = (newValue) => {
        // alert(value)
        // alert(e.target.value)
        // setComman({ ...comman, maxPrice: value });
        setValue(newValue);
        // getProduct(1);


        // setComman({ ...comman, maxPrice: value });
    }



    const addClass = (e, type) => {
        if (type == "short") {
            document.getElementsByTagName('body')[0].setAttribute("class", 'open_sort');
        }
        else {
            document.getElementsByTagName('body')[0].setAttribute("class", 'open_filter');
        }
    }


    const removeClass = (f, type) => {
        if (type == "short") {
            document.getElementsByTagName('body')[0].setAttribute("class", '');
        }
        else {
            document.getElementsByTagName('body')[0].setAttribute("class", '');
        }

        // alert(type)


    }

    return (
        <>
        <LoadingOverlay active={isActive} spinner>
            <Helmet>
                <title>{metaLocal[currentLang].title}</title>
                <meta name="description" content={metaLocal[currentLang].description} />
                <meta name="keywords" content={metaLocal[currentLang].keyword} />
            </Helmet>
            <Header new={params.type} data={true} isScrolled={isScrolled} />
            <main>
                {filters.data ?
                    <section className="space-cls banner-sec">
                        <div className="container">
                            {filters.data.limited_product.length > 0 &&
                                <OwlCarousel className="owl-carousel  owl-theme" {...options}  >
                                    {filters.data.limited_product.map((option, index) =>
                                        <div className="item">
                                            <div className="banner-img">
                                                <a href={'/product/' + (option.type != "product" ? option.type : "product-detail") + "/" + option.banner_for_id}>
                                                    <picture>
                                                        <source media="(min-width:575.98px)" srcSet={option.file} />
                                                        <img src={option.file} alt={option.file} />
                                                    </picture>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                    {/* {filters.data.limited_product.map((option, index) => { */}
                                    {/* <div className="item">
                              <div className="banner-img">
                                 <picture>
                                    <source media="(min-width:575.98px)" srcSet={option.file} />
                                    <img src={option.file} alt="" />
                                 </picture>
                              </div>
                           </div> */}

                                    {/* <div className="item">
                        <div className="banner-img">
                           <picture>
                              <source media="(min-width:575.98px)" srcSet={ImgBannerPrd} />
                              <img src={ImgMBannerPrd} alt="" />
                           </picture>
                        </div>
                     </div>
                     <div className="item">
                        <div className="banner-img">
                           <picture>
                              <source media="(min-width:575.98px)" srcSet={ImgBannerPrd} />
                              <img src={ImgMBannerPrd} alt="" />
                           </picture>
                        </div>
                     </div> */}
                                    {/* })} */}
                                </OwlCarousel>
                            }

                        </div>
                    </section> : null}
                <section className="space-cls product_listing tfb_only">
                    <div className="container">
                        <div className="product_wrap row">
                            <div className={`product_right_s ${isScrolled ? 'is_scrolled' : ''}`}>
                                {filters.data && (
                                    <TopFilterBar
                                        filters={filters.data}
                                        comman={comman}
                                        setComman={setComman}
                                        strings={strings}
                                        priceBounds={priceBounds}
                                        priceInput={priceInput}
                                        setPriceInput={setPriceInput}
                                        onChange={() => { setProduct([]); setHasMore(true); setCurrPage(1); }}
                                    />
                                )}
                                <div className="relative-loading" >
                                    {product.data ? product.data.length > 0 ?
                                        <InfiniteScroll
                                            // scrollableTarget="ProductList"
                                            dataLength={product.data.length}
                                            // scrollThreshold={0.80}
                                            next={onNext}
                                            hasMore={hasMore}
                                            loader={<div class="loader"></div>}
                                        >
                                            <ProductList showAddtoCart={showAddtoCart} data={product.data} handleFavourite={handleFavourite} />
                                            {/* </InfiniteScroll> */}

                                            {/* <ProductList data={product.data} handleFavourite={handleFavourite} /> */}
                                        </InfiniteScroll>
                                        :
                                        <section className="space-cls no_image review_noImg">
                                            <div className="container">
                                                <div className="cart_row">
                                                    <div className='col-md-12'>
                                                        <h3>
                                                            <center>
                                                                <img src={noProduct} alt="Out of stock" />
                                                            </center>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </section> : ''}
                                </div>

                                {/* <div className={"load-more d-flex justify-content-center mt-2 " + comman.showLoad}>

                           <button type="button" className="btn btn_primary" onClick={loadMore}>Load More</button>
                        </div> */}

                                {/*<div className="sale-sec">
                     <OwlCarousel className="owl-carousel  owl-theme" {...flowersOption}  > 
                
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale1} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale2} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale3} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale4} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale1} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale2} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale3} alt=""/>
                              </a>
                            </div>
                          </div>
                          <div className="item">
                            <div className="sale-prd">
                              <a href="#">
                                <img src={ImgmSale4} alt=""/>
                              </a>
                            </div>
                          </div>
                        
                        </OwlCarousel>
    </div>*/}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </LoadingOverlay>
        {modalIsOpen ? <>
				<Modal id="selectionModal" show={true} animation={true} size="lg" backdrop="static" keyboard={false} centered>
					<Modal.Header className="modal-header-custom">
						{/* <h5 className="modal-title">{strings.pickItemSize}</h5> */}
						<button
						type="button"
						className="btn-close"
						aria-label="Close"
						onClick={setModalIsOpenToFalse}
						>
						<img src={Imgcross} alt="Close" />
						</button>
					</Modal.Header>
					<Modal.Body className="modal-body-custom">
						<ValidationForm ref={formRef}>
						<div className="product-details">
							<img src={comman.product.image} alt={comman.product.name} className="product-image" />
							<div className="product-info">
								<h6 className="product-name">{comman.product.name}</h6>
								{/* Size Options */}
								<Form.Group className="form-group prd-size-group" controlId="form-group">
									<div className="prd_size_label">
									{comman.attributes[0]?.attribute_values &&
										comman.attributes[0].attribute_values.map((option, i) => (
										<label className="custom_radio_b" key={option.id}>
											<input
											type="radio"
											name="attribute_value_id"
											value={option.id}
											defaultChecked={i === 0}
                                            onChange={(e) => handleAttributeChange(comman.product.id, option.id)}
											/>
											<span className="checkmark">{option.value}</span>
										</label>
										))}
									</div>
								</Form.Group>
							</div>
							<div className="product-price">
								<Currency data={comman.product.discount_price != 0 ? comman.product.discount_price : comman.product.original_price} />
							</div>
						</div>

						{/* Submit Button */}
						<div className="login-btn">
							<Button
							onClick={(e) => addtoCart(comman.product_id, 'form', comman.product_variant_image)}
							type="button"
							className="btn btn-primary w-100"
							>
							{strings.pickThisSize}
							</Button>
						</div>
						</ValidationForm>
					</Modal.Body>
				</Modal></> : ""}
        </>
    )
}

export default ProductPage;
